<template>
  <v-container class="fill-height align-center">
    <v-row justify="center">
      <v-card max-width="600" class="ma-5">
        <v-card-title>パスワード リセット</v-card-title>
        <v-card-text>
          <p>ご登録のメールアドレスにパスワードリセット専用のURL（アドレス）を送ります。</p>
          <p>メールに記載のURLより、新しいパスワードをご設定ください。</p>
          <p>記載URLの有効期限は30分です。</p>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="loginId"
                    label="ログインID"
                    :rules="[v => !!v || '入力してください']"
                    required
                  />
                </v-col>
                <v-col cols="12" class="d-flex justify-end">
                  <v-btn color="grey darken-1" text @click="$router.push('/')">戻る</v-btn>
                  <v-spacer />
                  <v-btn color="primary" dark @click="send">送信</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>

      <v-dialog v-model="dialog" max-width="300">
        <v-card>
          <v-card-title>送信完了</v-card-title>
          <v-card-text>
            <p>メールをご確認ください。</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="grey darken-1" text @click="closeDialog">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'PasswordReset',

  data: () => ({
    dialog: false,
    formValid: true,
    loginId: ''
  }),
  methods: {
    send() {
      if (this.$refs.form.validate() === false) {
        return;
      }
      this.$store.dispatch('passwordResetSend', { login_id: this.loginId })
        .then(() => {
          this.dialog = true;
        })
        .catch(() => {
          alert('エラー：送信できませんでした。');
        });
    },
    closeDialog() {
      this.dialog = false;
      this.$router.push('/');
    }
  }
};
</script>
